import homeApi from './homeApi'
import liveManage from './liveManage'
import storeCertification from './storeCertification'
import popularization from './popularization'
import creativeCenter from './creativeCenter'
import setMeal from './setMeal'
import activateCode from './activateCode'
import mealManage from './mealManage'

export default {
  ...setMeal,
  ...homeApi,
  ...liveManage,
  ...storeCertification,
  ...popularization,
  ...creativeCenter,
  ...activateCode,
  ...mealManage
}
